/**
 * Students Resource Page
 * Manage flight students
 */

import React from 'react';
import { Typography, Button, Space, message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import {
  useResources,
  useToggleResourceAvailability,
} from '@/hooks/useCalendars';
import { ResourceTable } from '@/components/features/goldenwings/ResourceTable';
import type { Resource } from '@/api/types/calendars.types';

const { Title } = Typography;

export const StudentsPage: React.FC = () => {
  const { t } = useTranslation();
  // Students can be PILOT, PASSENGER, or PERSON types
  const { data: resources = [], isLoading } = useResources({
    resource_type: 'PILOT', // TODO: Filter multiple types
  });
  const toggleAvailability = useToggleResourceAvailability();

  const handleEdit = (resource: Resource) => {
    message.info(`Edit student: ${resource.name}`);
  };

  const handleDelete = (resource: Resource) => {
    message.info(`Delete student: ${resource.name}`);
  };

  const handleToggleAvailability = async (resource: Resource) => {
    try {
      await toggleAvailability.mutateAsync({
        resourceId: resource.id,
        data: {
          is_available: !resource.is_available,
          availability_notes: !resource.is_available
            ? 'Made available'
            : 'Made unavailable',
        },
      });
    } catch (error) {
      // Error handled by mutation
    }
  };

  const handleCreate = () => {
    message.info('Create new student');
  };

  return (
    <div style={{ padding: 24 }}>
      <Space
        direction="vertical"
        size="large"
        style={{ width: '100%', marginBottom: 24 }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Title level={2} style={{ margin: 0 }}>
            {t('goldenwings.students')}
          </Title>
          <Button type="primary" icon={<PlusOutlined />} onClick={handleCreate}>
            Add Student
          </Button>
        </div>

        <ResourceTable
          resourceType="PILOT"
          resources={resources}
          loading={isLoading}
          onEdit={handleEdit}
          onDelete={handleDelete}
          onToggleAvailability={handleToggleAvailability}
        />
      </Space>
    </div>
  );
};
